// extracted by mini-css-extract-plugin
export default {"InfoBanner":"InfoBanner_InfoBanner__Cicnw","IconWrapper":"InfoBanner_IconWrapper__msL+F","Icon":"InfoBanner_Icon__W+hm9"};